import { Directive, EventEmitter, HostBinding, inject, Input, Output } from '@angular/core';
import { UserService } from 'services/user.service';

@Directive({
	selector: 'img[userImage]'
})
export class UserImageDirective {

	private userService = inject(UserService);
	private _userId?: string;

	@Input('userImage') public set userId(userId: string | undefined) {
		if (userId == this._userId) return;
		this.imageUrl = undefined;
		this._userId = userId;
		this.userService.getProfileImageUrlByUserId(userId).then(url => {
			this.imageUrl = url;
			if (!url) this.onMissingImage.emit();
		});
	}
	@Output() public onMissingImage = new EventEmitter<void>();
	@HostBinding('src') public imageUrl?: string;
}
